import { useState, type JSX } from 'react';
import { isVideoUrl } from '@/utils/mediaUtils';
import styles from './ReviewMediaThumbnail.module.css';
import type { ReviewMediaThumbnailProps } from './ReviewMediaThumbnail.types';

export const ReviewMediaThumbnail = ({
  src,
  alt,
  onClick,
  className,
  isLast,
  moreCount,
}: ReviewMediaThumbnailProps): JSX.Element => {
  const [isLoaded, setIsLoaded] = useState(false);
  const isVideo = isVideoUrl(src);

  return (
    <div className={className} onClick={onClick}>
      {!isLoaded && <div className={styles.shimmer} />}
      {isVideo ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          src={src}
          className={`${styles.thumbnailMedia} ${isLoaded ? styles.loaded : ''}`}
          onLoadedData={() => setIsLoaded(true)}
        />
      ) : (
        <img
          src={src}
          alt={alt}
          className={`${styles.thumbnailMedia} ${isLoaded ? styles.loaded : ''}`}
          onLoad={() => setIsLoaded(true)}
        />
      )}
      {isLast && <div className={styles.photoOverlay}>+{moreCount} more</div>}
    </div>
  );
};
